
import { Statistic, Card, Row, Col, Tooltip } from 'antd';
import { ArrowUpOutlined, BorderOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from "react"; 
import styles from "./styles.css";
import CommonUtil from './CommonUtil.js';


const StatsCards  = ({wholeData }) => {
  
  const [active, setActive] = React.useState(0);
  const [confirmed, setConfirmed] = React.useState(0);
  const [deaths, setDeaths] = React.useState(0);
  const [recovered, setRecovered] = React.useState(0);
  const [deltaConfirmed, setDeltaConfirmed] = React.useState(0);
  const [deltaDeaths, setDeltaDeaths] = React.useState(0);
  const [deltaRecovered, setDeltaRecovered] = React.useState(0);
  const [lastupdatedtime, setLastupdatedtime] = React.useState(0);
  const [active_short, setActive_short] = React.useState(0);
  const [confirmed_short, setConfirmed_short] = React.useState(0);
  const [deaths_short, setDeaths_short] = React.useState(0);
  const [recovered_short, setRecovered_short] = React.useState(0);

  function getStatsData(){
     for (var key in wholeData["statewise"]) {
        if ((wholeData["statewise"][key]["statecode"] == "TT") && (wholeData["statewise"][key]["state"] == "Total"))  {
          console.log("Found : ",wholeData["statewise"][key]);
          setActive(wholeData["statewise"][key]["active"])
          setConfirmed(wholeData["statewise"][key]["confirmed"])
          setDeaths(wholeData["statewise"][key]["deaths"])
          setRecovered(wholeData["statewise"][key]["recovered"])
          setDeltaConfirmed(wholeData["statewise"][key]["deltaconfirmed"])
          setDeltaDeaths(wholeData["statewise"][key]["deltadeaths"])
          setDeltaRecovered(wholeData["statewise"][key]["deltarecovered"])
          setLastupdatedtime(wholeData["statewise"][key]["lastupdatedtime"])
          setActive_short(CommonUtil.getNumberShortner(wholeData["statewise"][key]["active"]))
          setConfirmed_short(CommonUtil.getNumberShortner(wholeData["statewise"][key]["confirmed"]))
          setDeaths_short(CommonUtil.getNumberShortner(wholeData["statewise"][key]["deaths"]))
          setRecovered_short(CommonUtil.getNumberShortner(wholeData["statewise"][key]["recovered"]))
          break;
        }
      }
  }

  useEffect(() => {
    getStatsData()
    // console.log("Props : ",wholeData)
  }, []); // <-- Have to pass in [] here!


  function small_number(number) {
    var newNumber = CommonUtil.getNumberShortner(number)
    return(
        <Tooltip title="Daily change">
            <span className="daily-updates-stats">({newNumber}+)</span>
        </Tooltip>
        )
  }


  return (
    <div className="site-statistic-card">
        <span className="last-updated-time-span">Last updated {lastupdatedtime}</span>
        <div style={{marginTop: "3%"}}>
          <Row gutter={16} style={{"rowGap":"8px"}}>
            <Col xs={12} xl={6}>
              <Card>
                <Statistic
                  title="Active"
                  value={active_short}
                  precision={0}
                  valueStyle={{ color: '#3f8600' }}
                  suffix={(<span className="daily-updates-stats">+</span>)}
                  prefix=""
                />
              </Card>
            </Col>
            <Col xs={12} xl={6}>
              <Card>
                <Statistic
                  title="Confirmed"
                  value={confirmed_short}
                  precision={0}
                  valueStyle={{ color: '#3f8600' }}
                  suffix={small_number(deltaConfirmed)}
                  prefix=""
                />
              </Card>
            </Col>
            <Col xs={12} xl={6}>
              <Card>
                <Statistic
                  title="Recovered"
                  value={recovered_short}
                  precision={0}
                  valueStyle={{ color: '#3f8600' }}
                  suffix={small_number(deltaRecovered)}
                  prefix=""
                />
              </Card>
            </Col>
            <Col xs={12} xl={6}>
              <Card>
                <Statistic
                  title="Deaths"
                  value={deaths_short}
                  precision={0}
                  valueStyle={{ color: '#cf1322' }}
                  suffix={small_number(deltaDeaths)}
                  prefix=""
                />
              </Card>
            </Col>
          </Row>
        </div>
      </div>
  );
}

export default StatsCards;
